import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Heart } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const data = await exchangeSession(sessionId);
        setUser(data.user);
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch (e) {
        setError(e?.response?.data?.detail || e.message || "Could not sign you in.");
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-14 h-14 rounded-2xl bg-[var(--fcc-ink)] text-white flex items-center justify-center mx-auto animate-pulse">
          <Heart className="w-6 h-6" />
        </div>
        <p className="font-display text-2xl text-[var(--fcc-ink)] mt-6">Signing you into KidHQ…</p>
        {error && <p className="text-sm text-[var(--fcc-red)] mt-4 max-w-sm mx-auto">{error}</p>}
      </div>
    </div>
  );
}
